var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatternFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.791,
    height: 317.306,
    viewBox: "0 0 158.791 317.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2590"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4288",
    transform: "translate(0 299.683)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4289",
    transform: "translate(52.826 158.654)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h.008v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4290",
    transform: "translate(0 141.03)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v35.245H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4291",
    transform: "translate(17.611 176.292)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h35.223v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4292",
    transform: "translate(70.444 176.292)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12354",
    d: "m760.293 358.527-17.611-4.608v22.23-.011l17.611-17.6z",
    transform: "translate(-707.459 -164.594)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12355",
    d: "M775.75 397.01v17.622h17.611V397h-8.8v.008z",
    transform: "translate(-758.139 -185.439)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12356",
    d: "M709.613 397.01v17.622h17.612V397h-8.8v.008z",
    transform: "translate(-656.78 -185.439)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12357",
    d: "M709.613 430.129v35.251h17.612V430.113h-8.8v.016z",
    transform: "translate(-656.78 -218.542)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12358",
    d: "M661.088 414.64v-17.623h-17.611z",
    transform: "translate(-555.421 -185.446)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12373",
    d: "M643.477 397.017v17.623h17.612z",
    transform: "translate(-520.053 -185.446)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12359",
    d: "M643.477 231.577V249.2h17.612z",
    transform: "translate(-555.421 -108.169)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4293",
    transform: "translate(0 229.213)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12360",
    d: "m742.7 319.947 17.6-4.608-17.6-17.622z",
    transform: "translate(-707.474 -139.063)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4294",
    transform: "translate(52.833 158.653)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4295",
    transform: "translate(52.834 176.292)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v.008H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12361",
    d: "M727.216 343.053h.008l4.605-17.622h-4.605v-4.608l-17.6 4.608z",
    transform: "translate(-656.783 -149.135)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12362",
    d: "M808.819 496.223v35.245l17.611-17.622v-17.623z",
    transform: "translate(-808.819 -231.784)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4296",
    transform: "translate(52.833 282.061)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4297",
    transform: "translate(35.222 299.683)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12363",
    d: "M742.683 513.846v17.622h17.611v-17.622H777.9l-17.611-17.622z",
    transform: "translate(-725.072 -231.785)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4298",
    transform: "translate(70.444 299.683)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h35.223v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4299",
    transform: "translate(88.056 264.439)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12364",
    d: "M742.682 463.154v17.622H777.9v-17.612h-17.607v-.009z",
    transform: "translate(-725.071 -216.338)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12365",
    d: "M610.408 463.154v17.622h17.611v-17.612h-8.806v-.009z",
    transform: "translate(-504.741 -216.338)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12375",
    d: "M610.408 463.154v17.622h17.611v-17.612h-8.806v-.009z",
    transform: "translate(-469.228 -216.338)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12376",
    d: "M610.408 463.154v17.622l17.611-17.613h-8.806z",
    transform: "translate(-486.984 -181.093)",
    style: {
      fill: "#212121"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2591"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4300",
    transform: "translate(0 141.03)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4301",
    transform: "translate(52.826 .001)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h.008v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4302",
    transform: "translate(0 .001)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v35.26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4303",
    transform: "translate(0 17.639)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h35.223v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12366",
    d: "M777.9 66.2h-35.218v17.627h17.611v-.011l17.611-17.6z",
    transform: "translate(-725.071 -30.924)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12367",
    d: "M775.75 99.312v52.878h17.611V99.288h-8.8v.024z",
    transform: "translate(-758.139 -81.648)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4304",
    transform: "translate(0 70.56)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4305",
    transform: "translate(52.834 70.56)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4306",
    transform: "translate(88.056 52.915)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4307",
    transform: "translate(105.667 17.643)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12368",
    d: "M742.7 17.625h17.6L742.7 0z",
    transform: "translate(-707.474 -.001)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4308",
    transform: "translate(52.833)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4309",
    transform: "translate(52.834 17.639)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v.008H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12369",
    d: "M709.613 50.722v.008h17.611V33.116z",
    transform: "translate(-656.779 -15.468)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12370",
    d: "M808.819 198.508v35.245l17.611-17.622v-17.623z",
    transform: "translate(-808.819 -92.723)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12371",
    d: "M709.613 233.753h17.611v17.622h17.611v-17.622h17.611v-17.622h-17.61v-17.623z",
    transform: "translate(-692.002 -92.723)",
    style: {
      fill: "#212121"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4310",
    transform: "translate(70.444 141.03)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4315",
    transform: "translate(123.423 141.03)",
    style: {
      fill: "#212121"
    },
    d: "M0 0h17.611v17.622H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12372",
    d: "M742.682 150.01v17.622H777.9v-17.6l-17.611-17.622v17.6z",
    transform: "translate(-725.071 -61.847)",
    style: {
      fill: "#212121"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternFooter);
export default __webpack_public_path__ + "static/media/pattern-footer.da880e560623d485d0e83ed35b3ce16b.svg";
export { ForwardRef as ReactComponent };